export const departamentos = [{ 'descripcion': 'ALTO PARANA', 'codigo': 11 }];
// Detectar se está rodando no Capacitor
const isCapacitor = () => {
    return typeof window !== 'undefined' && window.Capacitor;
};

// URL baseada no ambiente
export const url = isCapacitor()
    ? "https://pixtick.com.br/api"
    : "https://pixtick.com.br/api" // Para produção
// : "http://localhost:3002"; // Para desenvolvimento web

// export const url = "https://pixtick.com.br/api";
// export const url = "https://factura.mercadot.com.br/api";
export const masks = {
    '+55': { name: 'Brasil', mask: '(xx) xxxxx-xxxx' },
    '+54': { name: 'Argentina', mask: '(x) xxxx xx-xxxx' },
    '+595': { name: 'Paraguay', mask: '(xxx) xxx-xxx' },
    '+1': { name: 'EUA', mask: '(xxx) xxx-xxxx' }
    // Adicione outras máscaras conforme necessário
};

//export const roles = ['MASTER', 'ADMIN', 'USER', 'GUEST'];
export const roles = [
    { value: 'ADMIN', label: 'Administrador' },
    { value: 'USER', label: 'Usuário' }
];

export const nomeHost = "Pixtick";
export const PAGE_SIZE = 20;
